module.exports = __webpack_public_path__ + "img/lookbook_4_center.13a3f948.png";